var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#0057A0",
    strokeWidth: 1.1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.28 8.61c.121-.379.273-.748.452-1.103M.963 11.978A7.797 7.797 0 0 1 .94 10.26M2.107 15.17a7.794 7.794 0 0 1-.73-1.481M4.51 17.586a7.821 7.821 0 0 1-1.305-1.04M7.817 18.754a7.776 7.776 0 0 1-1.654-.374M6.968 3.165H8.7a7.821 7.821 0 0 1 .862 15.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1 6.968 3.165 10 5.331"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateBack);
export default __webpack_public_path__ + "static/media/rotate-back.ca82c1e308938c9d84ff83392facd11c.svg";
export { ForwardRef as ReactComponent };